import { Character } from '../models';
import ApiResource from './ApiResource';

class CharacterResource extends ApiResource<Character> {
  static isRouterResource = true;

  public endpoint = '/characters';
}

export const characterResource = new CharacterResource();
